import WidgetModule from "@eisinc/Overrides/Widgets/Requisitions/RequisitionsRequisitionLineRow";

export * from "@eisinc/Overrides/Widgets/Requisitions/RequisitionsRequisitionLineRow";

export default WidgetModule;
